import { Button } from '@mantine/core';
import { RouterProvider } from 'react-router-dom';
import { createRoutes } from './routes/createRoutes';
import { useKeycloakStore, useUserDataStore } from './shared_stores';
import { LoadingPage } from './shared_components';
import { observer } from 'mobx-react-lite';
import { Settings } from 'luxon';
import { setZodErrorMap } from '../config/setupTranslations';

export const App = observer(() => {
  Settings.throwOnInvalid = true;
  setZodErrorMap();

  const kcStore = useKeycloakStore();
  const userDataStore = useUserDataStore();

  if (kcStore.failedInitialization) {
    // TODO: CBYN-1 pass correct error message and tracing id
    return (
      <>
        Keycloak Connection Error
        {<Button onClick={() => kcStore.disableKeycloak()}>Disable KC</Button>}
      </>
    );
  }

  if (!kcStore.initialized && !kcStore.initializingInProgress) {
    void kcStore.initKeycloak();
    console.debug('initKeycloak in progress');
    return <LoadingPage />;
  }

  if (kcStore.initializingInProgress) {
    console.debug('initializing in progress');
    return <LoadingPage />;
  }

  if (
    kcStore.authenticated &&
    !userDataStore.loadedUserData &&
    !userDataStore.failedLoadingUserData
  ) {
    void userDataStore.loadUserData(kcStore.token);
    console.debug('loading user data in progress');
    return <LoadingPage />;
  }

  if (userDataStore.loadingUserData) {
    console.debug('loading user data in progress');
    return <LoadingPage />;
  }

  return <RouterProvider router={createRoutes(kcStore.authenticated)} />;
});

export default App;
